// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityProjects-module__create-project-btn--sl8mn";
export { _1 as "createProjectBtn" }
